export default __webpack_public_path__ + "static/biodiversity-mobile-banner-bd99639baffbe499e00870a3d03c122d.png";